import { render, staticRenderFns } from "./dialog-confirmdeletesharefile.vue?vue&type=template&id=cedc1a9e&"
import script from "./dialog-confirmdeletesharefile.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmdeletesharefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports